import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BoxHistory from '../../../components/assessmentTimeline/BoxHistory';
import SendNotificationButton from '../../../components/button/SendNotificationButton';
import { AssessmentConstants } from '../../../shared/Constants';
import { Loading } from '../../../components/Loading';

class JPSTimeLineBox extends Component {
  render() {
    const {
      JPSData, sendRemindingEmail, sendInviteEmail, isEmailSending,
    } = this.props;
    if (!JPSData) {
      return <Loading />;
    }
    const {
      submittedOn, expiresOn, declinedOn, invitedOn, startedOn, createdOn,
    } = JPSData;
    return (
      <div className="mt30 panel panel-default panel-padded">
        <div className="panel-body">
          <div className="timeline">
            {submittedOn ? (
              <div className="timeline-item">
                <div className="timeline-header">
                  <BoxHistory status={AssessmentConstants.ASMT_STATUS.SUBMITTED} date={submittedOn} />
                </div>
              </div>
            ) : null}

            {JPSData.status === AssessmentConstants.ASMT_STATUS.EXPIRED ? (
              <div className="timeline-item">
                <div className="timeline-header">
                  <BoxHistory status={AssessmentConstants.ASMT_STATUS.EXPIRED} date={expiresOn} />
                </div>
              </div>
            ) : null}

            {declinedOn && JPSData.status === AssessmentConstants.ASMT_STATUS.DECLINED ? (
              <div className="timeline-item">
                <div className="timeline-header">
                  <BoxHistory status={AssessmentConstants.ASMT_STATUS.DECLINED} date={declinedOn} />
                </div>
              </div>
            ) : null}

            {startedOn ? (
              <div className="timeline-item">
                <div className="timeline-header">
                  <BoxHistory status={AssessmentConstants.ASMT_STATUS.STARTED} date={startedOn} />
                </div>

                {JPSData.status === AssessmentConstants.ASMT_STATUS.STARTED ? (
                  <SendNotificationButton
                    assessment={JPSData}
                    isDisabled={isEmailSending}
                    actionMethod={sendRemindingEmail}
                  />
                ) : null}
              </div>
            ) : null}

            {invitedOn ? (
              <div className="timeline-item">
                <div className="timeline-header">
                  <BoxHistory status={AssessmentConstants.ASMT_STATUS.INVITED} date={invitedOn} />
                </div>

                {JPSData.status === AssessmentConstants.ASMT_STATUS.INVITED ? (
                  <SendNotificationButton
                    assessment={JPSData}
                    isDisabled={isEmailSending}
                    actionMethod={sendRemindingEmail}
                  />
                ) : null}
              </div>
            ) : null}

            {createdOn ? (
              <div className="timeline-item">
                <div className="timeline-header">
                  <BoxHistory status={AssessmentConstants.ASMT_STATUS.NEW} date={createdOn} />
                </div>
                {JPSData.status === AssessmentConstants.ASMT_STATUS.NEW ? (
                  <SendNotificationButton
                    assessment={JPSData}
                    isDisabled={isEmailSending}
                    actionMethod={sendInviteEmail}
                  />
                ) : null}
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

JPSTimeLineBox.propTypes = {
  sendInviteEmail: PropTypes.func.isRequired,
  sendRemindingEmail: PropTypes.func.isRequired,
  isEmailSending: PropTypes.bool.isRequired,
  JPSData: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default JPSTimeLineBox;
